import React from 'react'
import { NavLink } from 'react-router-dom'
import Slider from "react-slick";

import { UseGlobelcourse } from './component/allcoursecontaxt/ALLCoursecontaxt';
import { BASE_URL } from './Config/Config';

function Teamarea() {
   const { instructer_detail } = UseGlobelcourse();

   const settings = {
    // dots: true, 
    infinite: true, // Infinite loop sliding
    speed: 500, // Transition speed in milliseconds
    slidesToShow: 4, // Number of slides visible at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: true, // Enable autoplay
    autoplaySpeed: 2000, // Time interval between slides in milliseconds
    responsive: [
      {
        breakpoint: 1024, // For screens less than 1024px
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // For screens less than 768px
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576, // For screens less than 576px
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  
  return (
   <>
   <div  className="team-area overflow-hidden space" id="team-sec">
  <div className="shape-mockup team-bg-shape1 jump-reverse d-xxl-block d-none" data-left="-2%" data-top={0}>
    <img src="assets/img/team/team-shape_1_1.png" alt="img" />
  </div>
  <div className="shape-mockup team-bg-shape2 jump d-xxl-block d-none" data-left="40%" data-top="20%">
    <img src="assets/img/team/team-shape_1_2.png" alt="img" />
  </div>
  <div className="shape-mockup team-bg-shape3 jump" data-left="5%" data-bottom="9%">
    <img src="assets/img/team/team-shape_1_3.png" alt="img" />
  </div>
  <div className="shape-mockup team-bg-shape4 spin" data-left="40%" data-bottom="20%">
    <img src="assets/img/team/team-shape_1_4.png" alt="img" />
  </div>
  <div className="shape-mockup team-bg-shape5 jump d-lg-block d-none" data-right="-7%" data-top="10%">
    <img src="assets/img/team/team-shape_1_5.png" alt="img" />
  </div>
  <div className="container">
    <div className="title-area text-center">
      <span className="sub-title"><i className="fal fa-book me-2" /> Our Team</span>
      <h2 className="sec-title">Meet Our Expert Team</h2>
      <p className="mb-30">At Auratech Academy, our team of seasoned professionals is dedicated to empowering you with the skills and knowledge needed to excel in the IT industry. With 18+ years of experience and a passion for teaching, our instructors are here to guide you every step of the way.</p>
    </div>
    
    <div className="row th-carousel slider-shadow" data-slide-show={4} data-lg-slide-show={3} data-md-slide-show={2} data-sm-slide-show={2} data-xs-slide-show={1}>
    
      {/* Single Item */}
    
      <Slider {...settings}>
       {
       instructer_detail.map((curinstrter , index)=>(
      <div className="col-lg-6"  key={index}>
        <div className="team-card style2">
          <div className="team-img-wrap" style={{margin:"10px"}}>
            <svg className="team-shape" xmlns="http://www.w3.org/2000/svg" width={327} height={337} viewBox="0 0 327 337" fill="none">
              <path d="M158.167 331C158.167 333.946 160.555 336.333 163.5 336.333C166.446 336.333 168.833 333.946 168.833 331C168.833 328.054 166.446 325.667 163.5 325.667C160.555 325.667 158.167 328.054 158.167 331ZM158.167 6C158.167 8.94552 160.555 11.3333 163.5 11.3333C166.446 11.3333 168.833 8.94552 168.833 6C168.833 3.05448 166.446 0.666667 163.5 0.666667C160.555 0.666667 158.167 3.05448 158.167 6ZM325 167.5C325 257.254 253.238 330 163.5 330V332C254.359 332 327 258.343 327 167.5H325ZM2.00012 167.5C2.00012 77.7618 73.7458 7 163.5 7V5C72.6574 5 0.00012207 76.6411 0.00012207 167.5H2.00012Z" fill="#0D5EF4" />
            </svg>
            <div className="team-img">
              <img src={ curinstrter.CourseInstructor_image ? `${BASE_URL}${curinstrter.CourseInstructor_image}` : '/profail.png'} alt="Team" />
            </div>
            <div className="team-social">
              <NavLink to="/" className="icon-btn">
                <i className="far fa-address-card" />
              </NavLink>
              <div className="th-social">
                             {/* <a target="_blank" href="https://twitter.com/"><i class="fab fa-twitter"></i></a>
                              <a target="_blank" href="https://facebook.com/"><i class="fab fa-facebook-f"></i></a>
                              <a target="_blank" href="https://instagram.com/"><i class="fab fa-instagram"></i></a> */}
              </div>
            </div>


          </div>
          <div className="team-content">
            <h3 className="team-title"><NavLink to={`/ourinstructer/`}>{curinstrter.CourseInstructor_name}</NavLink></h3>
            {/* <span className="team-desig">Founder &amp; CEO</span> */}
            <span className="team-desig">{curinstrter.CourseInstructor_desig}</span>
          </div>
        </div>
         </div>
     ))}
     </Slider>
    </div>
    <div className="btn-group mt-30 d-flex align-items-center justify-content-center">
      <NavLink to="/ourinstructer"className="th-btn">Become an Instructor On Our Online Platform<i className="fas fa-arrow-right ms-2" /></NavLink>
      <NavLink to="/contact"className="th-btn style7">Contact Us<i className="fas fa-arrow-right ms-2" /></NavLink>
    </div>
  </div>
</div>

   </>
  )
}

export default Teamarea
